export default __webpack_public_path__ + "static/media/Imagen1.20779b68.png";